import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { from, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (environment.authMock) {
    if (req.url.startsWith('/api/')) {
      const roles = localStorage.getItem('mockRoles') ?? '["admin"]';
      const parsed = JSON.parse(roles) as string[];
      return next(req.clone({ setHeaders: { 'X-Mock-Roles': parsed.join(',') } }));
    }
    return next(req);
  }

  if (!req.url.startsWith('/api/')) {
    return next(req);
  }

  const msal = inject(MsalService);
  const account = msal.instance.getActiveAccount();
  if (!account) {
    return next(req);
  }

  return from(
    msal.instance.acquireTokenSilent({
      scopes: environment.msalConfig.scopes,
      account,
    })
  ).pipe(
    switchMap((result) =>
      next(
        req.clone({
          setHeaders: { Authorization: `Bearer ${result.accessToken}` },
        })
      )
    ),
  );
};
